import React from 'react';
import './header.css';
// import {BiSearch} from 'react-icons/bi';
import bellicon from '../../image/bellicon.svg';
import Login from '../../image/login.svg';

function Header(props) {
  return (
    <div className="row header">
            <div className="col-6 Activites">{props.title}</div>
            <div className="col-4">
              <form action="">
                <input type="search" className='searchsty' placeholder="Search" />
              </form>
            </div>

            <div className="col-2 icons">
              <span><img src={bellicon} alt="" className="headericonimg"/></span>
              <span><img src={Login} alt="" className="headericonimg"/></span>
            </div>


          </div>
  )
}

export default Header;